module.exports = __webpack_public_path__ + "static/img/01student.ab4f4a88.png";